import { render } from "./Reports.vue?vue&type=template&id=73e58126&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=73e58126&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e58126"]])

export default __exports__